import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import './LineTypeList.css';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import '../../../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import Loader from '../../common/loader/Loader';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function LineTypeList(props) {
  const [agents, setAgents] = useState();
  const [redirect, setRedirect] = useState(null);
  const [showInfo, setshowInfo] = useState(true);
  const [renderShowsTotal, setrenderShowsTotal] = useState(true);
  const [value, setValue] = React.useState(0);
  const [selectedLineType, setSelectedLineType] = useState(0);
  const [isLoading, setIsLoading] = useState();

  useEffect(() => {
    setSelectedLineType(props.initialValue)
  }, [props.initialValue])

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleIddLineTypeChange = (event, newValue) => {
   
    props.setIdLineTypeOnMem(event.target.value, props.row);
    setSelectedLineType(newValue.props.value);
  };

  const useStyles = makeStyles({
    root: {
      width: '100%',
      overflowX: 'auto',
    },
    table: {
      minWidth: 230,
    },
    tableHead: {
      background: '#3f51b5',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: 'darkcyan !important',
      },
    },

    tableRow: {
      '&:hover': {
        backgroundColor: 'lightgrey !important',
      },
    },
    headerCell: {
      color: 'white',
    },
  });

  const classes = useStyles();

  /*const displayForm = async (data, index) => {
    console.log('Data', data);
    console.log('Index', index);
    let agent = agents[index];
    console.log('Agent', agent);
    await setRecord();
    await setRecord(agent);
    setshowInfo(false);
  };*/

  useEffect(() => {
    //Change for server api address
    setIsLoading(true);
    //Profile Props',props )
    const url =  process.env.REACT_APP_API2_URL +
    '/LineType/GetLineTypes';

    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
       
        setAgents(data);

        setIsLoading(false);
      });
  }, []);

  function selectedValues(row) {
    console.log(`You click row id: ${row.idLineType}`);

    setRedirect(row);
  }

  const options = {
    page: 1, // which page you want to show as default
    hideSizePerPage: true,
    sizePerPage: 15, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 1, // the pagination bar size.
    prePage: '<', // Previous page button text
    nextPage: '>', // Next page button text
    firstPage: 'First', // First page button text
    lastPage: 'Last', // Last page button text
    paginationShowsTotal: renderShowsTotal, // Accept bool or function
    paginationPosition: 'bottom', // default is bottom, top and both is all available
    // hideSizePerPage: true > You can hide the dropdown for sizePerPage
    // alwaysShowAllBtns: true // Always show next and previous button
    withFirstAndLast: false, // > Hide the going to First and Last page button
    //expandRowBgColor: 'rgb(196, 222, 222)',
    // afterDeleteRow: onAfterDeleteRow, // A hook for after droping rows.
    //handleConfirmDeleteRow: customConfirm,
    onRowClick: selectedValues,
  };

  const cellEditProp = {
    mode: 'click', //DBClick daba problemas con el Expand se cambio a click
    beforeSaveCell: onBeforeSaveCell, // a hook for before saving cell
    //afterSaveCell: onAfterSaveCell, // a hook for after saving cell
  };

  function onBeforeSaveCell(row, cellName, cellValue) {
    // You can do any validation on here for editing value,
    // return false for reject the editing
    return true;
  }
  const printInputList = () => {
    return (
      <div>
        <FormControl className={`${classes.formControl} w-full`} size='small' variant='outlined'>
          <InputLabel shrink id="demo-simple-select-placeholder-label-label">
            Line Types
          </InputLabel>
          <Select
            labelId="demo-simple-select-placeholder-label-label"
            id="demo-simple-select-placeholder-label"
            value={selectedLineType}
            onChange={handleIddLineTypeChange}
            displayEmpty
            className={classes.selectEmpty}
          >
            {agents &&
              agents.map((row) => (
                <MenuItem value={row.idLineType} key={row.idLineType}>{row.description}</MenuItem>
              ))}
          </Select>
        </FormControl>
      </div>
    );
  };
  const printList = () => {
    return (
      <div id="main-div profile-list" class="profile-list">
        <Paper className={classes.root}>
          <h2>Line Types</h2>

          {options &&
            console.log('LineTypeList rendering typeof', typeof agents)}

          {isLoading ? <Loader></Loader> : ''}
          <Table className={classes.table} aria-label="simple table">
            <TableBody className={showInfo ? 'show-table' : 'hide-table'}>
              {agents && (
                <div>
                  <BootstrapTable
                    pagination={true}
                    options={options}
                    cellEdit={cellEditProp} //DBClick daba problemas con el Expand
                    version="4"
                    data={agents}
                    // deleteRow={true}
                    hover
                  >
                    <TableHeaderColumn
                      isKey={true}
                      filter={{ type: 'TextFilter', delay: 1000 }}
                      dataField="description"
                    >
                      Description
                    </TableHeaderColumn>
                  </BootstrapTable>
                </div>
              )}
            </TableBody>
          </Table>
        </Paper>
      </div>
    );
  };

  if (redirect) {
    let pushURL = '/lineType/' + redirect.idLineType;
    console.log('Profile Info props redirect', redirect);
    props.setLineType(redirect);
    printList();
    setRedirect(null);
    return (
      <div>
        <Redirect
          to={{
            pathname: pushURL,
          }}
        />

        {}
      </div>
    );

    //history.push(pushURL);
  }

  if (props.isInput) {
    return printInputList();
  } else {
    return printList();
  }
}

export default LineTypeList;
